var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskIconEnvironmental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3423_5508)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3423_5508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 20.0004H18.0004V22.0004H6.00041V20.0004H11.0004V18.9504C9.41488 18.7912 7.89035 18.2555 6.55377 17.3879C5.21719 16.5202 4.10725 15.3458 3.31641 13.9624L5.05341 12.9704C5.66419 14.0377 6.51278 14.9497 7.53326 15.6358C8.55374 16.3219 9.71864 16.7635 10.9375 16.9263C12.1563 17.0891 13.3963 16.9688 14.5611 16.5746C15.7259 16.1805 16.7841 15.5231 17.6536 14.6536C18.5231 13.7841 19.1805 12.7259 19.5746 11.5611C19.9688 10.3963 20.0891 9.15632 19.9263 7.93748C19.7635 6.71864 19.3219 5.55374 18.6358 4.53326C17.9497 3.51278 17.0377 2.66419 15.9704 2.05341L16.9624 0.316406C18.4934 1.19095 19.7659 2.45491 20.6507 3.98004C21.5355 5.50517 22.0012 7.2372 22.0004 9.00041C22.0004 14.1854 18.0534 18.4494 13.0004 18.9504V20.0004ZM12.0004 16.0004C11.0812 16.0004 10.1709 15.8193 9.32162 15.4676C8.47234 15.1158 7.70067 14.6002 7.05066 13.9502C6.40065 13.3001 5.88503 12.5285 5.53325 11.6792C5.18147 10.8299 5.00041 9.91966 5.00041 9.00041C5.00041 8.08115 5.18147 7.1709 5.53325 6.32162C5.88503 5.47234 6.40065 4.70067 7.05066 4.05066C7.70067 3.40065 8.47234 2.88503 9.32162 2.53325C10.1709 2.18147 11.0812 2.00041 12.0004 2.00041C13.8569 2.00041 15.6374 2.7379 16.9502 4.05066C18.2629 5.36341 19.0004 7.14389 19.0004 9.00041C19.0004 10.8569 18.2629 12.6374 16.9502 13.9502C15.6374 15.2629 13.8569 16.0004 12.0004 16.0004Z",
    fill: "#09121F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3423_5508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3423_5508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskIconEnvironmental);
export default __webpack_public_path__ + "static/media/risk-icon-environmental.c6e54e7eea25eaf227e97cd42b197f55.svg";
export { ForwardRef as ReactComponent };